var _Circle, _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgChooseAccount = function SvgChooseAccount(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "white",
    stroke: "#4285F4",
    strokeWidth: 4
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16.67 29.996c3.036 0 5.536-2.403 5.536-5.416 0-3.013-2.5-5.416-5.535-5.416-3.036 0-5.536 2.403-5.536 5.416 0 3.013 2.5 5.416 5.536 5.416ZM12.822 30.5a4.982 4.982 0 0 0-4.64 3.167c-1.014 2.595.9 5.398 3.685 5.398h9.607c2.787 0 4.7-2.803 3.686-5.398a4.982 4.982 0 0 0-4.64-3.167h-7.698Z",
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 1.763
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M42.954 29.996c3.035 0 5.535-2.403 5.535-5.416 0-3.013-2.5-5.416-5.535-5.416s-5.535 2.403-5.535 5.416c0 3.013 2.5 5.416 5.535 5.416ZM39.105 30.5a4.982 4.982 0 0 0-4.64 3.167c-1.014 2.595.9 5.398 3.685 5.398h9.608c2.786 0 4.7-2.803 3.685-5.398a4.982 4.982 0 0 0-4.64-3.167h-7.698Z",
    fill: "#494949",
    stroke: "white",
    strokeWidth: 1.763
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M29.675 31.56c3.883 0 7.056-3.111 7.056-6.98 0-3.87-3.173-6.98-7.056-6.98s-7.057 3.11-7.057 6.98c0 3.869 3.174 6.98 7.057 6.98ZM24.85 32.175a6.418 6.418 0 0 0-5.987 4.107c-1.29 3.342 1.176 6.938 4.759 6.938h12.106c3.582 0 6.049-3.596 4.759-6.938a6.418 6.418 0 0 0-5.988-4.107H24.85Z",
    fill: "#F7931A",
    stroke: "white",
    strokeWidth: 2.3
  })));
};
export default SvgChooseAccount;